import FileIcon from './FileIcon';

export default FileIcon;
